var _ellipse, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle2, _circle3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottomLeftLanding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 302,
    viewBox: "0 0 233 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: -9.112,
    cy: 241.558,
    rx: 189.813,
    ry: 189.273,
    transform: "rotate(19.3911 -9.112 241.558)",
    fill: "url(#paint0_radial_1081_49)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: -8.94268,
    cy: 241.617,
    r: 154.729,
    transform: "rotate(19.3911 -8.94268 241.617)",
    fill: "#EA1889"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.009 292.99C149.473 257.581 148.639 218.848 134.662 184.008C120.686 149.169 94.5202 120.598 61.0408 103.619C27.5613 86.6408 -10.9488 82.4123 -47.3148 91.7217C-83.6807 101.031 -115.422 123.243 -136.625 154.22C-157.829 185.197 -167.048 222.826 -162.565 260.096C-158.082 297.366 -140.202 331.735 -112.258 356.8C-84.3137 381.865 -48.2102 395.917 -10.674 396.337C26.8623 396.757 63.2712 383.517 91.7694 359.083L-8.94268 241.617L137.009 292.99Z",
    fill: "#9F18D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.009 292.99C148.318 260.861 148.709 225.898 138.122 193.524C127.535 161.15 106.562 133.174 78.4544 113.935C50.347 94.6956 16.6768 85.2686 -17.3343 87.1159C-51.3454 88.9632 -83.7965 101.981 -109.655 124.152C-135.513 146.322 -153.333 176.405 -160.352 209.735C-167.37 243.065 -163.194 277.78 -148.472 308.495C-133.75 339.211 -109.304 364.21 -78.9261 379.615C-48.548 395.021 -13.9354 399.973 19.5436 393.702L-8.94268 241.617L137.009 292.99Z",
    fill: "#57F2B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.009 292.99C147.17 264.123 148.542 232.892 140.953 203.245C133.364 173.599 117.154 146.868 94.3726 126.435C71.5916 106.001 43.2629 92.7812 12.9687 88.4475C-17.3254 84.1138 -48.2244 88.8608 -75.8207 102.088C-103.417 115.315 -126.471 136.429 -142.068 162.758C-157.665 189.088 -165.104 219.452 -163.444 250.009C-161.785 280.567 -151.101 309.946 -132.744 334.431C-114.387 358.917 -89.1816 377.409 -60.315 387.57L-8.94268 241.617L137.009 292.99Z",
    fill: "#EA1889"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.009 292.99C146.027 267.37 148.142 239.828 143.142 213.131C138.141 186.435 126.202 161.525 108.523 140.905C90.8445 120.286 68.0496 104.683 42.4297 95.6653C16.8097 86.6476 -10.7326 84.5326 -37.429 89.533C-64.1254 94.5334 -89.0352 106.473 -109.655 124.152C-130.274 141.83 -145.877 164.625 -154.895 190.245C-163.913 215.865 -166.027 243.407 -161.027 270.104C-156.027 296.8 -144.087 321.71 -126.408 342.33L-8.94268 241.617L137.009 292.99Z",
    fill: "#9F18D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137.009 292.99C144.889 270.603 147.514 246.703 144.679 223.139C141.845 199.575 133.628 176.979 120.664 157.099C107.7 137.219 90.3362 120.588 69.9164 108.492C49.4966 96.396 26.5679 89.1595 2.90401 87.3424C-20.7599 85.5252 -44.5246 89.1762 -66.5518 98.0127C-88.579 106.849 -108.278 120.634 -124.126 138.302C-139.973 155.97 -151.543 177.046 -157.942 199.901C-164.341 222.756 -165.397 246.776 -161.027 270.104L-8.94268 241.617L137.009 292.99Z",
    fill: "#57F2B9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M137.009 292.99C150.634 254.281 148.324 211.745 130.587 174.739C112.85 137.734 81.1386 109.29 42.4297 95.6653C3.72077 82.0405 -38.8152 84.3508 -75.8207 102.088C-112.826 119.825 -141.27 151.536 -154.895 190.245L-8.94268 241.617L137.009 292.99Z",
    fill: "#EA1889"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M137.009 292.99C148.318 260.861 148.709 225.898 138.122 193.524C127.535 161.15 106.562 133.174 78.4544 113.935C50.347 94.6956 16.6768 85.2686 -17.3343 87.1159C-51.3454 88.9632 -83.7965 101.981 -109.655 124.152L-8.94268 241.617L137.009 292.99Z",
    fill: "#9F18D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137.009 292.99C146.027 267.37 148.142 239.828 143.142 213.131C138.141 186.435 126.202 161.525 108.523 140.905C90.8445 120.286 68.0496 104.683 42.4297 95.6653C16.8097 86.6476 -10.7326 84.5326 -37.429 89.533L-8.94268 241.617L137.009 292.99Z",
    fill: "#57F2B9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M137.009 292.99C143.756 273.823 146.661 253.515 145.559 233.226C144.457 212.936 139.369 193.063 130.587 174.739C121.804 156.416 109.499 140.002 94.3726 126.435C79.2466 112.867 61.5964 102.412 42.4297 95.6653L-8.94268 241.617L137.009 292.99Z",
    fill: "#EA1889"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M137.009 292.99C146.027 267.37 148.142 239.828 143.142 213.131C138.141 186.435 126.202 161.525 108.523 140.905L-8.94268 241.617L137.009 292.99Z",
    fill: "#9F18D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M137.009 292.99C146.027 267.37 148.142 239.828 143.142 213.131L-8.94268 241.617L137.009 292.99Z",
    fill: "#57F2B9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: -9.05214,
    cy: 241.388,
    r: 25.0086,
    transform: "rotate(19.3911 -9.05214 241.388)",
    fill: "#D396ED"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: -9.05262,
    cy: 241.388,
    r: 14.9332,
    transform: "rotate(19.3911 -9.05262 241.388)",
    fill: "#57F2B9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1081_49",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-123.404 -83.4921) rotate(47.6614) scale(659.165 661.044)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169475,
    stopColor: "#4B00CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B00CC",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomLeftLanding);
export default __webpack_public_path__ + "static/media/bottom-left-landing.7a6077855a176cbccf882db198c77336.svg";
export { ForwardRef as ReactComponent };